import React, { Dispatch, SetStateAction } from "react";

export const Context = React.createContext({
  loading: false,
  tableData:null,
  
});